import { message } from "antd";
import { sortPostbySections } from "../../utils/sortPostBySections";
import http from "../http";
import { modalState } from "./modalAction";
import { queryClient } from "../../index";

const getPosts = (
  size = 10,
  page = 1,
  category,
  search,
  searchByBlog,
  searchByAuthor,
  searchByTag,
  blogId
) => {
  return (dispatch) => {
    return uGetPosts(
      {
        size,
        page,
        category,
        search,
        searchByBlog,
        searchByAuthor,
        searchByTag,
        blogId,
      },
      true
    )
      .then((data) => {
        dispatch({
          type: "GET_POSTS",
          posts: data.posts,
          postCount: data.count,
          postCurrent: page,
        });

        return "success";
      })
      .catch((err) => {
        // message.error(err.response?.data.message[0]);
        dispatch({
          type: "GET_POSTS",
          posts: [],
          postCount: 0,
          postCurrent: 1,
        });
        console.error(err);
        return "error";
      });
  };
};

const uGetPosts = (
  {
    size = 10,
    page = 1,
    category,
    search,
    searchByBlog,
    searchByAuthor,
    searchByTag,
    blogId,
    searchByUserId,
    tagIds,
  },
  sorted = false
) => {
  let params = {};
  if (category) params["category"] = category;
  if (search !== "#") params["search"] = search;
  if (searchByBlog) params["blog"] = searchByBlog;
  if (searchByAuthor) params["author"] = searchByAuthor;
  if (searchByTag) params["tag"] = searchByTag;
  if (blogId) params["blogId"] = blogId;
  if (searchByUserId) params["userId"] = searchByUserId;
  if (tagIds) params["tagIds"] = encodeURIComponent(tagIds);

  return http
    .get(`/blog_posts?size=${size}&page=${page}`, {
      params,
    })
    .then((res) => {
      const data = res?.data?.data;
      return sorted
        ? {
            ...data,
            posts: sortPostbySections(data.posts),
          }
        : data;
    });
};

const deletePost = (postId) => (dispatch) => {
  http
    .delete(`/blog_posts/${postId}`)
    .then(({ data }) => {
      message.success(data.message || "Delete Successful!");
      dispatch({ type: "DELETE_POST", postId: postId });
      queryClient.invalidateQueries({ queryKey: ["GetMyPosts"] });
    })
    .catch(({ response }) => {
      // message.error(response?.data.message[0]);
      console.error(response);
    });
};

const getPostDetails = (isSlug, id) => {
  return (dispatch) => {
    const URL = isSlug ? `/blog_posts/slug/${id}` : `/blog_posts/${id}`;
    http
      .get(URL)
      .then((res) => {
        const data = res.data.data;
        dispatch({
          type: "GET_POST_DETAIL",
          post: data,
        });
      })
      .catch((err) => {
        // message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const createPost = (body) => {
  return (dispatch) => {
    return http
      .post(`/blog_posts`, body)
      .then((res) => {
        message.success("Post added Successfully");
        return res.data.data;
      })
      .catch((err) => {
        // message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const updatePost = (postId, body) => {
  return (dispatch) => {
    return http
      .put(`/blog_posts/${postId}`, body)
      .then((res) => {
        message.success("Post updated Successfully");
        return res.data.data;
      })
      .catch((err) => {
        // message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const getBookmarks = (size = 100, page = 1) => {
  return (dispatch, getState) => {
    http
      .get(
        `/blog_posts/bookmarks?size=${size}&page=${page}&userId=${
          getState().auth.userData.id
        }`
      )
      .then((res) => {
        const data = res.data.data;
        dispatch({
          type: "GET_BOOKMARKS",
          bookmarks: data.bookmarks,
          bookmarkCount: data.count,
          bookmarkCurrent: page,
        });
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const addBookmark = (postId) => {
  return (dispatch) => {
    return http
      .post(`/blog_posts/${postId}/add_bookmark`)
      .then(async (res) => {
        await dispatch(getBookmarks());
        message.success("Bookmarked Successfully");
        return res.data.data.id;
      })
      .catch(({ response }) => {
        message.error(response?.data.message[0]);
        if (response.status === 401) {
          dispatch(modalState(true));
        }
      });
  };
};

const removeBookmark = (postId) => {
  return (dispatch) => {
    return http
      .delete(`/blog_posts/${postId}/remove_bookmark`)
      .then(async (res) => {
        await dispatch(getBookmarks());
        message.success("Bookmark removed Successfully");
        queryClient.invalidateQueries({ queryKey: ["GetBookmarks"] });
        return res.data.data.id;
      })
      .catch((err) => {
        message.error(err.response?.data.message[0]);
        console.error(err);
      });
  };
};

const updateLike = (postId, type) => {
  return (dispatch) => {
    return http[type](`/blog_posts/${postId}/likes`)
      .then((res) => {
        dispatch(getPostDetails(false, postId));
        return res.data.data.id;
      })
      .catch(({ response }) => {
        message.error(response?.data.message[0]);
        if (response.status === 401) {
          dispatch(modalState(true));
        }
      });
  };
};

const searchPosts = (term) => (dispatch) => {
  http
    .get(`/blog_posts?page=${1}&size=${5}&search=${term}&status=active`)
    .then(({ data }) => {
      let search = [];
      data.data.posts.map((p) => {
        search.push({ imgUrl: p.imageUrl, title: p.title });
      });
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: search,
      });
    })
    .catch(({ response }) => {
      dispatch({
        type: "SET_SUGGESTIONS",
        suggestions: [],
      });
    });
};

const updateBlogPostsShareCount = (blogPostId) => (dispatch) => {
  http
    .put(`/blog_posts/${blogPostId}/share`)
    .then(() => {
      //message.success("");
      return true;
    })
    .catch((err) => {
      //message.error(err.response?.data.message[0]);
      console.error(err);
    });
};

const updateBlogShareCount = (blogId) => (dispatch) => {
  http
    .put(`/blogs/${blogId}/share`)
    .then(() => {
      //message.success("");
      return true;
    })
    .catch((err) => {
      //message.error(err.response?.data.message[0]);
      console.error(err);
    });
};

const updateBlogPostFlagging = (blogId) => (dispatch) => {
  console.log("blogId", blogId);
  http
    .put(`/blog_posts/${blogId}/flag`)
    .then(() => {
      message.success("Post Flagged Successfully");
      return true;
    })
    .catch((err) => {
      message.info(err.response?.data.message[0]);
    });
};

export {
  getPosts,
  deletePost,
  getPostDetails,
  createPost,
  updatePost,
  getBookmarks,
  addBookmark,
  removeBookmark,
  updateLike,
  uGetPosts,
  searchPosts,
  updateBlogShareCount,
  updateBlogPostsShareCount,
  updateBlogPostFlagging,
};
